import { render, staticRenderFns } from "./ExpedicaoDetalhes.vue?vue&type=template&id=5d4c3413"
import script from "./ExpedicaoDetalhes.vue?vue&type=script&lang=js"
export * from "./ExpedicaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports